import React from 'react';

const hasValue = (value) => {
  return (firstValue = true, ...values) => firstValue && [firstValue, ...values].includes(value);
};

export const useOpenState = (defaultValue = null) => {
  const [state, setState] = React.useState({
    value: defaultValue,
    isOpen: hasValue(defaultValue),
  });

  const open = (value = true, params = null) => {
    setState({
      value,
      params,
      isOpen: hasValue(value),
    });
  };

  const close = () => {
    setState({
      value: null,
      isOpen: () => false,
    });
  };

  return [state, open, close];
};
